import moment from 'moment';
import AssessmentItem from './assessment-item.entity';
import EmployeeAssessmentResult from './employee-assessment-result';

export default class Assessment {
  id: string;

  assignmentDescription: string;

  levelId: string;

  levelName: string;

  responseDate: string;

  lastUpdatedDate?: string;

  total: number;

  skillValue: number;

  knowledgeValue: number;

  responsibilityValue: number;

  behavioralValue: number;

  employeeName: string;

  employeeUsername: string;

  currentSeniority: string;

  items: AssessmentItem[];

  assignmentId: string;

  result: EmployeeAssessmentResult;

  constructor(obj: any = {}) {
    this.id = obj.id || '';
    this.assignmentId = obj.assignmentId || '';
    this.assignmentDescription = obj.assignmentDescription || '';
    this.levelId = obj.levelId || '';
    this.levelName = obj.levelName || '';
    this.responseDate = obj.responseDate || '';
    this.lastUpdatedDate = obj.lastUpdatedDate || '';
    this.total = obj.total || 0;
    this.skillValue = obj.skillValue || '';
    this.knowledgeValue = obj.knowledgeValue || '';
    this.responsibilityValue = obj.responsibilityValue || '';
    this.behavioralValue = obj.behaviorValue || '';
    this.currentSeniority = obj.currentSeniority || '';
    this.employeeName = obj.employeeName || '';
    this.employeeUsername = obj.employeeUsername || '';
    this.items = obj.items ? obj.items.map(it => new AssessmentItem(it)) : [];
    this.result = obj.result
      ? new EmployeeAssessmentResult(obj.result)
      : new EmployeeAssessmentResult();
  }

  get lastUpdatedDateFormatted(): string {
    if (!this.lastUpdatedDate) return '';
    return moment(this.lastUpdatedDate).format('DD/MM/YYYY HH:mm');
  }
}
